import { apiFetch } from '@/lib/api';

export interface UsersStats {
  total_admins: number;
  super_admins: number;
  admins: number;
  registered_users: number;
  subscribed_users: number;
}

export function getUsersStats(): Promise<UsersStats> {
  return apiFetch<UsersStats>('/admin-users/stats');
}
